import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  open = () => {
    zE('webWidget', 'show')
    zE('webWidget', 'open')
  }
}
